import type { Study } from '@pocketprep/types'
import { Parse } from '@/store/ParseUtils'
import * as Sentry from '@sentry/vue'
import { analyticsModule } from '@/store/analytics/module'

interface IUserModuleState {
    user: Study.Class.UserJSON | null
    dismissables: { [key: string]: boolean }
}

export const getInitialUserState = (): IUserModuleState => {
    const parseUserFromLocalStorage = Parse.User.current<Study.Class.User>()

    // update Sentry user context if signed in
    const user = parseUserFromLocalStorage?.toJSON() || null
    if (user) {
        Sentry.setUser({
            id: user.objectId,
            email: user.email,
        })
        analyticsModule.actions.setAmplitudeUser({
            id: user.objectId,
            email: user.email,
            createdAt: user.createdAt,
            currentOrgId: user.currentOrganization?.objectId,
        })
    }

    return {
        user,
        dismissables: {
            statsSneakPeek: true,
        },
    }
}

const moduleState = getInitialUserState()

export default moduleState

